module.exports = __webpack_public_path__ + "static/logo-white-793b245f77fe973a2fb565288083e855.png";